module.exports = __webpack_public_path__ + "media/src/images/icons/logout/blue-194ddc5d357f55daccb8faff601b9a6a.svg";